import { useSelector } from 'react-redux';
import { Col, Row, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import Card from '../../Components/Card';
import cl from './favorite.module.css';

const Favorite = () => {
    const favorite = useSelector((state) => state.favorite)?.items ?? [];
    const navigate = useNavigate();

    document.title = 'Избранное';

    return (
        <div className="main-page">
            <Row className="basket-page">
                <Typography className="title">Избранное</Typography>
                <div className={cl.wrapper}>
                    {favorite.length > 0 ? (
                        favorite.map((card) => (
                            <Card
                                key={card.id}
                                id={card.id}
                                title={card.title}
                                price={card.price}
                                article={card.article}
                                unit={card.unit}
                                media={card.media}
                                style={{ margin: 15 }}
                            />
                        ))
                    ) : (
                        <Col className="empty-basket-container">
                            <Row justify="center">
                                В избранных пока что ничего нет
                            </Row>
                            <Row className="go-to-catalog-container">
                                <span
                                    role="presentation"
                                    className="go-to-catalog"
                                    onClick={() => navigate('/')}
                                >
                                    Перейти к подбору товаров
                                </span>
                            </Row>
                        </Col>
                    )}
                </div>
            </Row>
        </div>
    );
};

export default Favorite;
